import { render, staticRenderFns } from "./TrainingProviders.vue?vue&type=template&id=c8880d2a"
import script from "./TrainingProviders.vue?vue&type=script&lang=js"
export * from "./TrainingProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports